namespace Gamification.Gamification {
    export interface TipologieCredenzialiForm {
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class TipologieCredenzialiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.TipologieCredenziali';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TipologieCredenzialiForm.init)  {
                TipologieCredenzialiForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(TipologieCredenzialiForm, [
                    'Nome', w0,
                    'Descrizione', w1
                ]);
            }
        }
    }
}
